import React, { useContext, useState, useRef } from 'react';
import styles from './ModalGrupyTechnologii.module.css';
import { TechnologyContext } from 'context/TechnologyContext';
import { getNameOfElementTyp } from 'actions/getNameOfElementTyp';
import { _typ_elementu } from 'utils/initialvalue';

const ModalGrupyTechnologii = ({ 
  modalGrupyOpen, 
  setModalGrupyOpen, contextMenu, selectedGrup
}) => {
  const { grupaWykonan, wykonania } = useContext(TechnologyContext);
  const [localgrupy, setLocalGrupy] = useState(grupaWykonan);
  const [localwykonania, setLocalWykonania] = useState(wykonania);

  // Stany do obsługi przeciągania
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const dragRef = useRef({ startX: 0, startY: 0 });

  if (!modalGrupyOpen) return null;

  const onClose = () => {
    setModalGrupyOpen(false);
  };

  const onConfirm = () => {
    setModalGrupyOpen(false);
  };

  const handleTechChange = (globalId, field, value) => {
    setLocalWykonania(prev => 
      prev.map(tech => 
        tech.global_id === globalId ? { ...tech, [field]: value } : tech
      )
    );
  };

  const handleConfirmClick = () => {
    if (onConfirm) {
      onConfirm({ localgrupy, localwykonania });
    }
    onClose();
  };

  // Obsługa rozpoczęcia przeciągania
  const handleMouseDown = (e) => {
    // Nie przeciągaj, jeśli kliknięto w przycisk zamknięcia
    if (e.target.closest('button')) return;
    
    setIsDragging(true);
    dragRef.current = {
      startX: e.clientX - position.x,
      startY: e.clientY - position.y
    };
  };

  // Obsługa ruchu myszy
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setPosition({
      x: e.clientX - dragRef.current.startX,
      y: e.clientY - dragRef.current.startY
    });
  };

  // Zakończenie przeciągania
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  return (
    <div 
      className={styles.overlay} 
      onMouseMove={handleMouseMove} 
      onMouseUp={handleMouseUp}
    >
      <div 
        className={styles.modal}
        style={{ transform: `translate(${position.x}px, ${position.y}px)` }}
      >
        
        {/* Nagłówek modala - uchwyt do przeciągania */}
        <div 
          onMouseDown={handleMouseDown}
          onDoubleClick={() => {
            console.table(grupaWykonan);
          }} 
          className={styles.header}
        >
          <h2 className={styles.title}>
            {selectedGrup?.nazwa} <span className={styles.titleMini}> {getNameOfElementTyp( selectedGrup?.typ_elementu,_typ_elementu)} </span> {selectedGrup?.nr}_{selectedGrup?.rok.substring(2,4)} {selectedGrup?.firma_nazwa} {selectedGrup?.tytul}
          </h2>
          <button onClick={onClose} className={styles.closeButton}>
            &times;
          </button>
        </div>

        {/* Zawartość modala */}
        <div className={styles.content}>
          {grupaWykonan?.filter(x => x.proces_id == selectedGrup?.proces_id).map((grupa) => {
            return (
              <div key={grupa.global_id} className={styles.groupCard}>
                
                <div className={styles.groupHeader}>
                  <span className={styles.groupTitle}>
                    Grupa ID: {grupa.id} — {grupa.nazwa} (Indeks: {grupa.indeks})
                  </span>
                  <div className={styles.groupInfo}>
                    <span>Nakład : <b>{grupa.naklad}</b></span>
                    <span>Narząd: <b>{grupa.narzad}</b></span>
                    <span>Początek: <b>{grupa.poczatek}</b></span>
                    <span>Czas: <b>{grupa.czas}</b></span>
                    <span>Koniec: <b>{grupa.koniec}</b></span>
                  </div>
                </div>

                {wykonania.length === 0 ? (
                  <p className={styles.noTech}>Brak przypisanych technologii wykonania.</p>
                ) : (
                  <div className={styles.tableContainer}>
                    <table className={styles.table}>
                      <thead>
                        <tr>
                          <th>Nr</th>
                          <th>Nakład</th>
                          <th>Czas (min)</th>
                          <th>Narząd</th>
                          <th>Przeloty</th>
                          <th>Prędkość</th>
                          <th>Początek</th>
                          <th>Koniec</th>
                        </tr>
                      </thead>
                      <tbody>
                        {wykonania.filter(wyk => wyk.grupa_id == grupa.id).map((tech) => (
                          <tr key={tech.global_id}>
                            <td>{tech.nr_arkusza}</td>
                            <td>
                              <input
                                type="number"
                                value={tech.naklad}
                                onChange={(e) => handleTechChange(tech.global_id, 'naklad', Number(e.target.value))}
                                className={styles.input}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                value={tech.czas}
                                onChange={(e) => handleTechChange(tech.global_id, 'czas', Number(e.target.value))}
                                className={styles.input}
                              />
                            </td>
                            <td>{tech.narzad}</td>
                            <td>{tech.przeloty}</td>
                            <td>{tech.predkosc}</td>
                            <td>{tech.poczatek}</td>
                            <td>{tech.koniec}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

              </div>
            );
          })}
        </div>

        {/* Stopka */}
        <div className={styles.footer}>
          <button type="button" onClick={onClose} className={styles.buttonCancel}>
            Anuluj
          </button>
          <button type="button" onClick={handleConfirmClick} className={styles.buttonConfirm}>
            Potwierdź zmiany
          </button>
        </div>

      </div>
    </div>
  );
};

export default ModalGrupyTechnologii;